/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/Layout'

const componentsRouter = {
    path: '/door',
    component: Layout,
    name: 'Door',
    menuid: 22,
    systemtypeid: 2,
    meta: {
      title: 'DoorTitle',
      icon: 'excel'
    },
    children: [
      {
        path: 'timeslot/index',
        component: () => import('@/views/door/timeslot/list'),
        name: 'DoorTimeSlotList',
        menuid: 23,
        systemtypeid: 2,
        meta: {title: 'TimeSlotList', icon: 'dashboard'}
      }, 
      {
        path: 'holiday/index',
        component: () => import('@/views/door/holiday/list'),
        name: 'DoorHolidayList',
        menuid: 36,
        systemtypeid: 2,
        meta: {title: 'HolidayList', icon: 'guide'}
      }, 
      {
        path: 'device/two',
        component: () => import('@/views/door/twodevice/list'),
        name: 'TwoDoorDeviceList',
        menuid: 27,
        systemtypeid: 2,
        meta: {title: 'TwoDeviceList', icon: 'bug'}
      },  
      {
        path: 'device/one',
        component: () => import('@/views/door/onedevice/list'),
        name: 'OneDoorDeviceList',
        menuid: 178,
        systemtypeid: 2,
        meta: {title: 'OneDeviceList', icon: 'bug'}
      }, 
      {
        path: 'device/talkback',
        component: () => import('@/views/door/talkback/list'),
        name: 'TalkBackList',
        menuid: 132,
        systemtypeid: 2,
        meta: {title: 'TalkBackList', icon: 'bug'}
      }, 
      {
        path: 'devicegroup/index',
        component: () => import('@/views/door/devicegroup/list'),
        name: 'DeviceGroupList',
        menuid: 31,
        systemtypeid: 2,
        meta: {title: 'DeviceGroupList', icon: 'peoples'}
      }, 
      {
        path: 'log',
        component: () => import('@/views/door/keylog/list'),
        name: 'KeyLogList',
        menuid: 46,
        systemtypeid: 2,
        meta: {title: 'KeyLogList', icon: 'message'}
      }, 
    ]
  }

export default componentsRouter



// WEBPACK FOOTER //
// ./src/router/modules/door.js